module.exports = __webpack_public_path__ + "img/brackets_big_right.5c5854b5.svg";